import { Link } from "react-router-dom";

type Props = {
  variant: "all_clear" | "bucket_empty";
};

export function CareerMoveEmptyState({ variant }: Props) {
  if (variant === "all_clear") {
    return (
      <div className="rounded-lg border border-border bg-card/40 px-6 py-12 text-center">
        <h2 className="text-lg font-semibold text-foreground">You&rsquo;re clear</h2>
        <p className="mt-2 text-sm text-muted-foreground">
          No high-impact career moves right now. Add a goal or activity to keep
          momentum, or check Analytics for pipeline depth.
        </p>
        <div className="mt-4 flex justify-center gap-2">
          <Link
            to="/goals"
            className="rounded-md border border-border px-3 py-1.5 text-sm hover:bg-muted/20"
          >
            Manage goals
          </Link>
          <Link
            to="/jobs/add"
            className="rounded-md bg-brand px-3 py-1.5 text-sm font-medium text-brand-foreground"
          >
            Add a job
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="rounded-lg border border-border bg-card/40 px-6 py-10 text-center">
      <h2 className="text-base font-semibold text-foreground">Nothing in this bucket</h2>
      <p className="mt-2 text-sm text-muted-foreground">
        Try another bucket or refresh the queue.
      </p>
    </div>
  );
}
